import React from "react";
import styled from "styled-components";

const SearchBox = () => {
    return (
        <Container>
            
        </Container>
    );
};

const Container = styled.div`
    width: 13.375rem;
    height: 2.4375rem;
    flex-shrink: 0;
    border: 1px solid #9BBEC8; /* border 속성을 사용하여 테두리 스타일, 두께 및 색상 지정 */
    border-radius: 10px; /* border-radius 속성 값 뒤에 단위(px)를 추가 */
`

export default SearchBox